import { useSetRecoilState } from 'recoil';
import { VideoAssetBody, VideoAssetResponse } from '../../../API';
import { VideoAssetsAPI } from '../../../hooks/API/VideoAssets/VideoAssetsAPI';
import { CacheManager, DataManagerHook, DataManagerHookReturnType, IDataManagerHookProps } from '../../DataManager';

export interface VideoAssetsHookReturnType extends DataManagerHookReturnType<VideoAssetResponse, VideoAssetBody> {
  getByFilePath: (filePath: string) => Promise<VideoAssetResponse | undefined>;
}

export function VideoAssetsHook(
  params: IDataManagerHookProps<VideoAssetResponse, VideoAssetBody>
): VideoAssetsHookReturnType {
  const dataManagerHook = DataManagerHook<VideoAssetResponse, VideoAssetBody>(params);
  const setCache = useSetRecoilState(params.state.withDataCache);
  const { addRecordToCache } = CacheManager(params.idField, setCache);

  const api = params.useApiHook() as VideoAssetsAPI;

  const getByFilePath = async (filePath: string): Promise<VideoAssetResponse | undefined> => {
    try {
      const {
        data: { body: asset }
      } = await api.getByFilePath(filePath);
      addRecordToCache(asset);
      return asset as VideoAssetResponse;
    } catch {
      return undefined;
    }
  };

  return {
    ...dataManagerHook,
    getByFilePath
  };
}
